/**
 * API para gestión de contactos de emergencia
 * Endpoints para crear, obtener, actualizar y eliminar contactos de emergencia
 */

import { fetchConToken, fetchSinToken } from '../utils/fetch.ts';

/**
 * Obtiene todos los contactos de emergencia de un alumno
 * @param {number} aluId - ID del alumno
 * @returns {Promise<Object>} Lista de contactos de emergencia
 */
export const obtenerContactosEmergencia = async (aluId) => {
  try {
    const resp = await fetchConToken(`contactos-emergencia/alumno/${aluId}`, {}, 'GET');
    if (!resp.ok) {
      return { error: true, message: 'Error al obtener contactos' };
    }
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error en obtenerContactosEmergencia:', error);
    return { error: true, message: error.message };
  }
};


/**
 * Obtiene todos los contactos de emergencia de un alumno
 * @param {number} aluId - ID del alumno
 * @returns {Promise<Object>} Lista de contactos de emergencia
 */
export const obtenerContactosEmergenciaPublico = async (aluId) => {
  try {
    const resp = await fetchSinToken(`contactos-emergencia/alumno-publico/${aluId}`, {}, 'GET');
    if (!resp.ok) {
      return { error: true, message: 'Error al obtener contactos' };
    }
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error en obtenerContactosEmergencia:', error);
    return { error: true, message: error.message };
  }
};


/**
 * Obtiene un contacto de emergencia específico
 * @param {number} cemId - ID del contacto de emergencia
 * @returns {Promise<Object>} Datos del contacto de emergencia
 */
export const obtenerContactoEmergencia = async (cemId) => {
  try {
    const resp = await fetchConToken(`contactos-emergencia/${cemId}`, {}, 'GET');
    if (!resp.ok) {
      return { error: true, message: 'Error al obtener contacto' };
    }
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error en obtenerContactoEmergencia:', error);
    return { error: true, message: error.message };
  }
};

/**
 * Crea un nuevo contacto de emergencia
 * @param {Object} data - Datos del contacto de emergencia
 * @returns {Promise<Object>} Resultado de la operación
 */
export const crearContactoEmergencia = async (data) => {
  try {
    const resp = await fetchConToken('contactos-emergencia/crear', data, 'POST');
    if (!resp.ok) {
      return { error: true, message: 'Error al crear contacto de emergencia' };
    }
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error en crearContactoEmergencia:', error);
    return { error: true, message: error.message };
  }
};

/**
 * Actualiza un contacto de emergencia
 * @param {number} cemId - ID del contacto de emergencia
 * @param {Object} data - Datos a actualizar
 * @returns {Promise<Object>} Resultado de la operación
 */
export const actualizarContactoEmergencia = async (cemId, data) => {
  try {
    const resp = await fetchConToken(`contactos-emergencia/${cemId}`, data, 'PUT');
    if (!resp.ok) {
      return { error: true, message: 'Error al actualizar contacto de emergencia' };
    }
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error en actualizarContactoEmergencia:', error);
    return { error: true, message: error.message };
  }
};

/**
 * Elimina un contacto de emergencia
 * @param {number} cemId - ID del contacto de emergencia
 * @returns {Promise<Object>} Resultado de la operación
 */
export const eliminarContactoEmergencia = async (cemId) => {
  try {
    const resp = await fetchConToken(`contactos-emergencia/${cemId}`, {}, 'DELETE');
    if (!resp.ok) {
      return { error: true, message: 'Error al eliminar contacto de emergencia' };
    }
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error en eliminarContactoEmergencia:', error);
    return { error: true, message: error.message };
  }
};
